import { render, staticRenderFns } from "./PaginacaoBase.vue?vue&type=template&id=19f4f9df&"
import script from "./PaginacaoBase.vue?vue&type=script&lang=js&"
export * from "./PaginacaoBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports